var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeroWaves(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1919.5 9.599h.5v162.5H600.196c129.01-49.716 346.378-111.764 513.804-42.5 149.33 61.779 345.32.219 521.47-55.11C1742.42 40.896 1842.05 9.6 1919.5 9.6z",
    fill: "url(#hero-waves_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.8 116.409c51.04 19.375 101.94 38.692 152.8 55.591H11v-7.614C182.361 97.07 451.797 4 640.939 4c152.686 0 301.4 56.443 448.861 112.409z",
    fill: "url(#hero-waves_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 241.183h1920v-73.264c-15.96-6.409-32.75-13.392-50.35-20.712l-.01-.005c-168.43-70.06-411.23-171.055-719.14-96.603-351.492 84.99-468.471 42.34-577.422 2.614C543.474 42.42 514.463 31.842 481.5 24.1 275.944-24.183 114.606 6.49 0 59.701v181.482z",
    fill: "url(#hero-waves_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero-waves_svg__a",
    x1: 1260.1,
    y1: 9.599,
    x2: 1260.1,
    y2: 172.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero-waves_svg__b",
    x1: 1271.1,
    y1: 9.5,
    x2: 1271.1,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero-waves_svg__c",
    x1: 1260.1,
    y1: 9.599,
    x2: 1260.1,
    y2: 172.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroWaves);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTkyMCAyMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0ibTE5MTkuNSA5LjU5OS41LjAwMDEyVjE3Mi4wOTlINjAwLjE5NmMxMjkuMDEtNDkuNzE2IDM0Ni4zNzgtMTExLjc2MzcgNTEzLjgwNC00Mi41IDE0OS4zMyA2MS43NzkgMzQ1LjMyLjIxOSA1MjEuNDctNTUuMTA5N0MxNzQyLjQyIDQwLjg5NTggMTg0Mi4wNSA5LjU5OTAxIDE5MTkuNSA5LjU5OVoiIGZpbGw9InVybCgjYSkiLz4KICA8cGF0aCBkPSJNMTA4OS44IDExNi40MDljNTEuMDQgMTkuMzc1IDEwMS45NCAzOC42OTIgMTUyLjggNTUuNTkxSDExdi03LjYxNEMxODIuMzYxIDk3LjA2OTYgNDUxLjc5NyA0LjAwMDAzIDY0MC45MzkgNGMxNTIuNjg2LS4wMDAwMiAzMDEuNCA1Ni40NDMxIDQ0OC44NjEgMTEyLjQwOVoiIGZpbGw9InVybCgjYikiLz4KICA8cGF0aCBkPSJNMCAyNDEuMTgzaDE5MjB2LTczLjI2NGMtMTUuOTYtNi40MDktMzIuNzUtMTMuMzkyLTUwLjM1LTIwLjcxMmwtLjAxLS4wMDVjLTE2OC40My03MC4wNTk3LTQxMS4yMy0xNzEuMDU1NC03MTkuMTQtOTYuNjAyOC0zNTEuNDkyIDg0Ljk4OTgtNDY4LjQ3MSA0Mi4zMzg5LTU3Ny40MjIgMi42MTQzLTI5LjYwNC0xMC43OTM5LTU4LjYxNS0yMS4zNzE4LTkxLjU3OC0yOS4xMTQyQzI3NS45NDQtMjQuMTgyNSAxMTQuNjA2IDYuNDg5MTkgMCA1OS43MDA3VjI0MS4xODNaIiBmaWxsPSJ1cmwoI2MpIi8+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIxMjYwLjEiIHkxPSI5LjU5OSIgeDI9IjEyNjAuMSIgeTI9IjE3Mi4wOTkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2ZmZiIgc3RvcC1vcGFjaXR5PSIuMiIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZmYiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSIxMjcxLjEiIHkxPSI5LjQ5OTc2IiB4Mj0iMTI3MS4xIiB5Mj0iMTcyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjIiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJjIiB4MT0iMTI2MC4xIiB5MT0iOS41OTkiIHgyPSIxMjYwLjEiIHkyPSIxNzIuMDk5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjIiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+";
export { ForwardRef as ReactComponent };